const supplierCatalog = [
    {
        selector: '[data-react="supplierCatalog"]',
        path: { filename: 'supplierCatalog' },
    },
];

export { supplierCatalog };
